module.exports = __webpack_public_path__ + "fe14bb3c81a590120618f17b80f4bcc8.ttf";